// Interceptor per proteggere /cart/update.js (production)
(function(){
  if (window.__cartUpdateInterceptorInstalled) return;
  window.__cartUpdateInterceptorInstalled = true;

  var queue = Promise.resolve();

  function isSameOriginOrRelative(url) {
    try {
      if (!url) return false;
      if (url.indexOf('/') === 0) return true;
      var u = new URL(url, location.href);
      return u.origin === location.origin;
    } catch (e) { return false; }
  }

  function readJsonBodyFromInit(init, input) {
    try {
      if (init && init.body && typeof init.body === 'string') {
        return JSON.parse(init.body);
      }
      if (init && init.body && typeof init.body !== 'string') return null;
      if (input && typeof input !== 'string' && input instanceof Request) {
        return input.clone().text().then(function(t){ try { return JSON.parse(t); } catch(e){ return null; }});
      }
    } catch(e) { }
    return null;
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function(input, init) {
    var reqUrl = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) ? init.method.toUpperCase() : (typeof input === 'string' ? 'GET' : (input && input.method) || 'GET');

    if (method === 'POST' && isSameOriginOrRelative(reqUrl) && reqUrl.indexOf('/cart/update.js') !== -1) {
      queue = queue.then(function(){
        return Promise.resolve(readJsonBodyFromInit(init, input))
        .then(function(originalBody){
          var originalAttrs = originalBody && originalBody.attributes ? originalBody.attributes : null;
          if (!originalAttrs) return originalFetch(input, init);
          return originalFetch('/cart.js', { credentials: 'same-origin' })
            .then(res => { if(!res.ok) throw new Error('Impossibile leggere /cart.js: ' + res.status); return res.json(); })
            .then(cart => {
              var current = cart.attributes || {};
              var merged = {...current};
              Object.keys(originalAttrs).forEach(k => originalAttrs[k]===null ? delete merged[k] : merged[k]=originalAttrs[k]);
              var newInit = {...init, body: JSON.stringify({ attributes: merged }), credentials: 'same-origin'};
              var headers = new Headers(newInit.headers || {});
              headers.set('Content-Type', 'application/json');
              newInit.headers = headers;
              return originalFetch('/cart/update.js', newInit);
            });
        });
      });
      return queue;
    }
    return originalFetch(input, init);
  };

  // XHR fallback
  (function(){
    if (!window.XMLHttpRequest) return;
    var NativeXHR = window.XMLHttpRequest;
    function InterceptedXHR(){
      var xhr = new NativeXHR(), _url=null, _method=null;
      var originalOpen = xhr.open;
      xhr.open = function(method,url){ _method=(method||'').toUpperCase(); _url=url; return originalOpen.apply(xhr,arguments); };
      var originalSend = xhr.send;
      xhr.send = function(body){
        try{
          if(_method==='POST' && isSameOriginOrRelative(_url) && _url.indexOf('/cart/update.js')!==-1){
            var originalAttrs=null;
            try{ if(typeof body==='string'){ var parsed=JSON.parse(body); originalAttrs=parsed && parsed.attributes ? parsed.attributes:null; } }catch(e){ originalAttrs=null; }
            if(!originalAttrs) return originalSend.apply(xhr,arguments);
            queue = queue.then(function(){
              return fetch('/cart.js',{credentials:'same-origin'})
                .then(res => { if(!res.ok) throw new Error('Impossibile leggere /cart.js: '+res.status); return res.json(); })
                .then(cart=>{
                  var current=cart.attributes||{}, merged={...current};
                  Object.keys(originalAttrs).forEach(k=>originalAttrs[k]===null?delete merged[k]:merged[k]=originalAttrs[k]);
                  return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:merged})});
                })
                .then(res=>res.text().then(text=>{
                  try{ Object.defineProperty(xhr,'status',{value:res.status,configurable:true}); }catch(e){}
                  try{ Object.defineProperty(xhr,'responseText',{value:text,configurable:true}); }catch(e){}
                  try{ if(typeof xhr.onreadystatechange==='function'){xhr.readyState=4;xhr.onreadystatechange();} if(typeof xhr.onload==='function')xhr.onload();}catch(e){}
                }));
            });
            return;
          }
        }catch(e){ return originalSend.apply(xhr,arguments); }
        return originalSend.apply(xhr,arguments);
      };
      return xhr;
    }
    InterceptedXHR.prototype = NativeXHR.prototype;
    window.XMLHttpRequest = InterceptedXHR;
  })();
})();